import { render, staticRenderFns } from "./AddToppingMenu.vue?vue&type=template&id=3b2656d8&scoped=true"
import script from "./AddToppingMenu.vue?vue&type=script&lang=js"
export * from "./AddToppingMenu.vue?vue&type=script&lang=js"
import style0 from "./AddToppingMenu.vue?vue&type=style&index=0&id=3b2656d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2656d8",
  null
  
)

export default component.exports